// https://developers.google.com/youtube/iframe_api_reference

import Util from './Utils';

class YTplayer {
    constructor( _option ){
        this.nameIs = 'class-YTplayer';
        this.playerIsReady = false;
        this.ytPlayer = null;
        this.option = $.extend(true, {
            el_sel: '',
            el_id: '',
            el_outer:null,
            width: '100%',
            height: '100%',
            videoId: '',
            playerVars: {
                mute: true, 
                start: 0,
                end: 0,
                controls: 0,
                playsinline: 1,
                autoplay: 0,
                showinfo: 0,
                rel: 0,
                disablekb:1
            }
        }, _option);
        
        if(!Util.objHasKeys( window, ['YT', 'Player'] )){
            this.initLoadAPI();
        } else {
            this.initPlayer();
        }
    }

    initLoadAPI(){
        window.onYouTubeIframeAPIReady = () => this.initPlayer();
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        document.head.appendChild(tag);
    }
    
    initPlayer(){
        this.ytPlayer = new YT.Player(this.option.el_id, this.option);
        this.addEvents();
    }
    
    addEvents(){
        this.ytPlayer.addEventListener('onReady', (e) =>{
            // console.log('youtube is ready', this.option.el_sel );
            this.playerIsReady = true;

            if( this.option.playerVars.mute ){
                this.mute();
            }else{
                this.unMute();
            }

            $(this.option.el_sel).trigger( {type: 'PLAYER_INIT_COMP', who: this.nameIs, videoId: this.option.videoId} );
        });

        // '-1:시작되지 않음, 0:종료됨, 1:재생 중, 2:일시중지됨, 3:버퍼링 중, 5:동영상이 신호를 받고 재생할 준비가 됐음'
        this.ytPlayer.addEventListener('onStateChange', (e) =>{
            let state = [`PLAYER_END`, `PLAYER_PLAY`, `PLAYER_PAUSE`, `PLAYER_BUFFERING`, `PLAYER_READY`][e.data];
            if(state) $(this.option.el_sel).trigger( {type: state,  who: this.nameIs} );
        });

      //  $(window).on( 'resize', (ev)=>{
          //  this.resize();
       // });
        this.resize();
    }

    resize(){
      this.option.el_outer.css('height', this.option.el_outer.width() * 0.5645);
    }
    /*
    * Public functions
    */
    play(){
        if(!this.playerIsReady) return;
        this.ytPlayer.playVideo();

        return this;
    }
    
    pause() {
        if(!this.playerIsReady) return;
        this.ytPlayer.pauseVideo();
    }
    
    stop(){
        if(!this.playerIsReady) return;
        this.ytPlayer.stopVideo();
    }

    mute(){
        if(!this.playerIsReady) return;
        this.ytPlayer.mute();
        $(this.option.el_sel).trigger( {type: 'PLAYER_MUTE',  who: this.nameIs} );
    }

    unMute(){
        if(!this.playerIsReady) return;
        this.ytPlayer.unMute();
        $(this.option.el_sel).trigger( {type: 'PLAYER_UNMUTE',  who: this.nameIs} );
    }

    //_obj = { videoId:'7qFfFVSerQo', startSeconds:60, endSeconds:70}
    nextPlay( _obj ){
        // console.log( 'next', _obj );
        if(!this.playerIsReady) return;
        this.ytPlayer.loadVideoById( _obj );
    }

    get isMuted(){
        if(!this.playerIsReady) return;
        return this.ytPlayer.isMuted();
    }
    
    get duration(){
        if(!this.playerIsReady) return;
        return this.ytPlayer.getDuration();
    }
    
    get time(){
        if(!this.playerIsReady) return;
        return this.ytPlayer.getCurrentTime();
    }

    set time( _time ){
        if(!this.playerIsReady) return;
        this.ytPlayer.seekTo( _time );
        $(this.option.el_sel).trigger( {type: 'PLAYER_SEEK',  who: this.nameIs} );
    }
    
    get volume(){
        if(!this.playerIsReady) return;
        return this.ytPlayer.getVolume();
    }
    
    set volume( _vol ){
        if(!this.playerIsReady) return;
        this.ytPlayer.setVolume( _vol );
        $(this.option.el_sel).trigger( {type: 'PLAYER_VOLUME',  who: this.nameIs} );
    }

    get vodId(){
        if(!this.playerIsReady) return;
        return this.ytPlayer.getVideoData().video_id;
    }

    get thumbURL(){
        if(!this.playerIsReady) return;
        return `http://i.ytimg.com/vi/${this.option.videoId}/maxresdefault.jpg`;
    }

    get isPaused(){
        if(!this.playerIsReady) return;
        let state = this.ytPlayer.getPlayerState();
        return state===2;
        /* 
            -1 –시작되지 않음
            0 – 종료
            1 – 재생 중
            2 – 일시중지
            3 – 버퍼링
            5 – 동영상 신호
         */
    }
    get outer(){
      return this.option.el_outer;
    }
    
}
export default YTplayer;